import ToricelliExperiment from "./containers/ToricelliExperiment";
export default ToricelliExperiment;